import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router";
import {LoadingState} from "../../../components/fouladyar/loading-state/loadingState";
import axios from "axios";
import {ErrorToaster} from "../../../shared/toaster";
import {IoMdArrowDropleft} from "react-icons/io";
import {useTranslation} from "react-i18next";
import {toFarsiNumber} from "../../../shared/toFarsiNumber";
import {LOGO_SVG, SELECT_PLAN} from "../../../shared/svg";

const Plans = () => {
    const auth = useSelector((state) => state.auth);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('tab1');
    const [isCardsLoading, setIsCardsLoading] = useState(true);
    const dispatch = useDispatch();
    const [productCategories, setProductCategories] = useState([]);
    const [varieties, setVarieties] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedVarietyId, setSelectedVarietyId] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isProductsLoading, setIsProductsLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)


    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };


    async function getVarieties() {
        try {
            // setIsCardsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/variety`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setVarieties(res.data.data.varieties)
                setSelectedVarietyId(res.data.data.varieties[0]?._id);
            }
            // setIsCardsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            // setIsProductsLoading(false)
        }

    }

    async function getProductCategories() {
        try {
            setIsCardsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories?section=product`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setProductCategories(res.data.data.categories)
                // setSelectedVarietyId(res.data.data.categories[1]?._id);

            }
            setIsCardsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsProductsLoading(false)
        }

    }

    async function getProductByVarietyId() {
        try {
            setIsProductsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/products/variety/${selectedVarietyId}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            if (res.data.statusCode === 200 || !res.data.statusCode) {
                console.log('product',res.data.data.products)
                setProducts(res.data.data.products?.sort((a, b) => parseInt(a.slug) - parseInt(b.slug)))
                setSelectedProduct(res.data.data.products[0])
            }

            setIsProductsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsProductsLoading(false)
        }
    }

    useEffect(() => {
        getVarieties();
        getProductCategories();
    }, []);

    useEffect(() => {
        if (selectedVarietyId)
            getProductByVarietyId(selectedVarietyId)
    }, [selectedVarietyId]);

    useEffect(() => {


        // console.log('item._id', varieties[0]._id)
    }, [varieties]);


    async function selectPlan() {
        try {
            setIsSubmitting(true)

            //Empty cart
            const emptyCartResponse = await axios.delete(`${process.env.REACT_APP_API_URL}/api/cart`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })
            console.log('emptyCartResponse', emptyCartResponse)

            if (emptyCartResponse.data.statusCode === 200) {
                //Add to cart
                console.log('selected-item', selectedProduct)
                const addToCartResponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/cart`,
                    {
                        item: {
                            productId: selectedProduct?._id,
                            varietyId: selectedVarietyId,
                            productType: selectedProduct?.type,
                            quantity: 1
                        }
                    }, {
                        headers: {authorization: `Bearer ${auth.token}`}
                    })

                if (addToCartResponse.data.statusCode === 200 || !addToCartResponse.data.statusCode) {
                    navigate('/checkout')
                }


            } else {
                ErrorToaster({message: 'خالی کردن سبد خرید ما مشکل مواجه شده است'}, t)

            }

            setIsSubmitting(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsSubmitting(false)
        }

    }

    return (
        <React.Fragment>
            {/*<ModalHelper*/}
            {/*    open={isModalOpen}*/}
            {/*    onOpen={() =>setIsModalOpen(true)}*/}
            {/*    onClose={() => setIsModalOpen(false)}*/}
            {/*    component={*/}
            {/*        <AddWalletComponent/>*/}
            {/*    }*/}
            {/*/>*/}

            <div className="nk-content ">
                <div className="container-fluid select-plan-container">

                    <h1>{"انتخاب پلن"}</h1>


                    <div className="spacer"/>
                    <h3>
                        در این بخش متناسب با سرمایه و ریسک خود پلن مورد نظر را انتخاب کنید
                    </h3>
                    <p>
                        لطفا در انتخاب طرح مورد نظر دقت کافی داشته باشید، چرا که بعد از انجام عملیات پرداخت، امکان تغییر
                        طرح وجود نداشته و مسئولیت آن تماما بر عهده خریدار خواهد بود. لذا در بررسی طرح مورد نظر خود را
                        متناسب با نیاز خود تهیه کنید.
                    </p>

                    <div className="spacer"/>
                    <div className="tab-buttons">
                        {
                            varieties?.map(item => {
                                return (
                                    <div onClick={() => setSelectedVarietyId(item?._id)}
                                         className={`selectable-button plan-btn ${selectedVarietyId === item?._id ? 'is-active' : ''}`}>
                                        {item.name}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={"plans-container"}>
                        {
                            isProductsLoading ? <LoadingState/> :
                                <div className="plans">
                                    <div className="plans-price">
                                        {
                                            products?.map(item => {
                                                return (
                                                    <div onClick={() => {
                                                        setSelectedProduct(item)
                                                    }}
                                                         className={`plans-price-item ${selectedProduct.slug === item.slug ? "selected-plan" : ""}`}>
                                                        <div className="plans-price-item-value">{toFarsiNumber(item.title)} دلاری</div>
                                                        <div className="plans-price-arrow"> {
                                                            selectedProduct.slug === item.slug ?
                                                                <IoMdArrowDropleft size={19} color={"#60E9B7"}/> : <></>
                                                        } </div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                    <div className="selected-plan-box">
                                        <div className="plan-description">
                                            <div className="plans-attributes-value">
                                                <div onClick={async () => {
                                                    if (!isSubmitting) {
                                                        console.log('item', selectedProduct?._id)
                                                        await selectPlan()
                                                    }
                                                }} className={`select-plan-button ${isSubmitting ? 'disabled' : ''}`}>
                                                    انتخاب پلن
                                                </div>
                                            </div>
                                            <div className="plans-description-text">{selectedProduct?.description} </div>
                                            <div className="plans-content-text">با پرداخت {toFarsiNumber(selectedProduct?.varieties?.find(i=>i?._id === selectedVarietyId)?.price )} دلار، حساب {toFarsiNumber(selectedProduct?.title)} دلاری دریافت کنید و تا ۱۰۰٪ از سود را برداشت بزنید</div>

                                            <div className="plans-title-text">{toFarsiNumber(selectedProduct?.varieties?.find(i=>i?._id === selectedVarietyId)?.price )} دلار</div>
                                            <div className="select-plan-logo">
                                                <div dangerouslySetInnerHTML={{__html: SELECT_PLAN}}/>
                                            </div>
                                        </div>
                                        <div className="plans-attributes" >
                                            {

                                                selectedVarietyId ? varieties.find(i=> i._id === selectedVarietyId).attributes?.map(item => {
                                                    return (
                                                        <div className="plans-attribute">
                                                            <div className="plans-attributes-key">{item.key}</div>
                                                            <div className="plans-attributes-value">{item.value}</div>
                                                        </div>
                                                    )
                                                }) : <></>
                                            }


                                        </div>
                                    </div>
                                </div>
                        }
                    </div>


                </div>
            </div>
        </React.Fragment>

    );
};

export default Plans;
